import ScoreDetails from './ScoreDetails';

export default ScoreDetails;
